export const ACTION_SET_IS_AUTH = "ACTION_SET_IS_AUTH"
export const ACTION_SET_USER_DATA = "ACTION_SET_USER_DATA"
export const ACTION_SET_GOOGLE_AUTH = "ACTION_SET_GOOGLE_AUTH"
export const ACTION_SET_STOP_CHECK_2FA = "ACTION_SET_STOP_CHECK_2FA"
export const ACTION_SET_USER_ROOL = "ACTION_SET_USER_ROOL"